import { defineMessage } from 'services/localization';

export const messages = {
    trackingColumnTitleText: defineMessage('fieldname_used_in_line___line_item_should_match'),
};
